/* eslint-disable */
import React, { useEffect, useState } from 'react'
import SidewaysChart from './SidewaysChart'
import FieldSVG from '../Helpers/FieldSVG'

export default function Sideways({ settings }) {
    const [svg, setSvg] = useState(null)

    const height = 327
    const width = 720

    if (settings.shape === 'twitter') {
    }
    const opts = {
        playData: settings.data,
        arcType: 'standard',
        colors: {
            bleachers: '#d8d8d8',
            ground: '#417505',
            hit: '#D0011B',
            metricMark: '#888',
        },
        height,
        width,
        hitTypeVisible: false,
        scaleType: 'true',
    }

    useEffect(() => {
        SidewaysChart(opts, (sidewaysSvg) => {
            setSvg(sidewaysSvg)
        })
    }, [])

    return (
        <>
            <g dangerouslySetInnerHTML={{ __html: svg }} />
            {/*
          <g transform="translate(0,-100) scale(.5)">
              <FieldSVG settings={settings} />
          </g>
          */}
        </>
    )
}
